module.exports = __webpack_public_path__ + "static/media/drop_arrow.00017f00.svg";